function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Search Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.5,0 C10.0891424,0 13,2.91085763 13,6.5 C13,7.85867826 12.5828686,9.12015704 11.8697169,10.1633254 L16.8535534,15.1464466 C17.0488155,15.3417088 17.0488155,15.6582912 16.8535534,15.8535534 C16.6582912,16.0488155 16.3417088,16.0488155 16.1464466,15.8535534 L11.2401402,10.9470744 C10.0542425,12.2105906 8.36909491,13 6.5,13 C2.91085763,13 0,10.0891424 0,6.5 C0,2.91085763 2.91085763,0 6.5,0 Z M6.5,1 C3.46314237,1 1,3.46314237 1,6.5 C1,9.53685763 3.46314237,12 6.5,12 C9.53685763,12 12,9.53685763 12,6.5 C12,3.46314237 9.53685763,1 6.5,1 Z",
  id: "search-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "search-Icon/Global/search",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "search-Swatches/DarkGreen",
  transform: "translate(4.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "search-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#search-path-1"
})));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.f1959da3.svg";
export { ForwardRef as ReactComponent };